import { PostgrestError } from '@supabase/supabase-js';
import { supabaseClient } from './supabase';

interface AllPvSizeQueryOptions {
  select: string;
  geofips: number;
  orderByYear?: boolean;
}

const buildGeoidVariants = (geofips: number) => {
  const raw = String(geofips).trim();
  const unpadded = raw.replace(/^0+/, '') || '0';
  const padded = raw.padStart(7, '0');
  const variants = new Set<string | number>([raw, unpadded, padded]);
  const numeric = Number(unpadded);
  if (!Number.isNaN(numeric)) {
    variants.add(numeric);
  }
  return Array.from(variants);
};

export const fetchAllPvSize = async <T = any>(
  options: AllPvSizeQueryOptions
): Promise<{ data: T[] | null; error: PostgrestError | null }> => {
  const geoidVariants = buildGeoidVariants(options.geofips);

  let query = supabaseClient
    .from('all_pv_size')
    .select(options.select)
    .in('geoid', geoidVariants);

  if (options.orderByYear !== false) {
    query = query.order('year', { ascending: true });
  }

  const { data, error } = await query;
  return { data: data as T[] | null, error };
};
